import request from '@/utils/request'


// 市场行情列表
export function listMarketByType(param) {
    return request({
        url: `/swx/customer/index/listMarketByType`,
        method: 'get',
        params: {
            ...param
        }
    })
}

// k线图
export function getKValueByCodeAndDate(param) {
    return request({
        url: `/swx/customer/index/getKValueByCodeAndDate`,
        method: 'get',
        params: {
            ...param
        }
    })
}
// getMarketInfo
export function getMarketInfo(id) {
    return request({
        url: `/swx/customer/index/getMarketInfo/${id}`,
        method: 'get',
        // params: {
        //     ...param
        // }
    })
}
// listContents
export function listContents(lang) {
    return request({
        url: `/swx/customer/index/listContents/${lang}`,
        method: 'get',
    })
}
// /getContentsById/{id}
export function getContentsById(id) {
    return request({
        url: `/swx/customer/index/getContentsById/${id}`,
        method: 'get',
    })
}

// /getParamByKey/{key}
export function getParamByKey(key) {
    // withdrawal_fee 提现手续费
    // recharge_account 充值账号


    return request({
        url: `/swx/customer/index/getParamByKey/${key}`,
        method: 'get',
        noAuth: true,
    })
}

// listNft
export function listNft(param) {
    return request({
        url: `/swx/customer/index/listNft`,
        method: 'get',
        params: {
            ...param
        }
    })
}

// buySmart
export function buySmart(data) {
    return request({
        url: `/swx/customer/order/buySmart`,
        method: 'post',
        data
    })
}
// listSmartOrder
export function listSmartOrder(param) {
    return request({
        url: `/swx/customer/order/listSmartOrder`,
        method: 'get',
        params: {
            ...param
        }
    })
}

// buyOptions
export function buyOptions(data) {
    return request({
        url: `/swx/customer/order/buyOptions`,
        method: 'post',
        data
    })
}

// 合约：
export function buyContracts(data) {
    return request({
        url: `/swx/customer/order/buyContracts`,
        method: 'post',
        data
    })
}

/**
 * 平仓合约订单
 */
export function closeContract(orderId) {
    return request({
        url: `/swx/customer/order/closeContracts/${orderId}`,
        method: 'post'
    })
}


export function getOptionsOrderById(id) {
    return request({
        url: `/swx/customer/order/getOptionsOrderById/${id}`,
        method: 'get',
    })
}
// listOptionsOrder
export function listOptionsOrder(param) {
    return request({
        url: `/swx/customer/order/listOptionsOrder`,
        method: 'get',
        params: {
            ...param
        }
    })
}

export function listOrder(param) {
    return request({
        url: `/swx/customer/order/listOrder`,
        method: 'get',
        params: {
            ...param
        }
    })
}

// 批量获取指定类型的设置
export function getSettingsByType(type) {
    return request({
        url: `/swx/customer/index/getSettingsByType/${type}`,
        method: 'get',
        noAuth: true,
    })
}

// 获取启用的交易分类
export function getEnabledMarketTypes() {
    return request({
        url: `/swx/customer/index/getEnabledMarketTypes`,
        method: 'get',
        noAuth: true,
    })
}

// 提交闪兑请求
export function submitFlashExchange(data) {
    return request({
        url: '/swx/customer/flash-exchange/submit',
        method: 'post',
        data
    })
}

